/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersEditComponent
 * Purpose		: This component retrieves data for the specified record id and allows to edit and save changes.
 * Dependency	: CustomersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit, HostBinding, EventEmitter, Input, Output,
         trigger, transition, animate,
         style, state } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { CustomersData, CustomersService }  from './Customers.service';



@Component({
  template: require('./CustomersEdit.component.html'),
  providers: [CustomersService
	
	],
  animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomersEditComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }
 
	objCustomers: CustomersData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

	constructor(private route: ActivatedRoute, 
		private router: Router,
		private toastr: ToastsManager,
		private CustomersService: CustomersService

	) {
		// this.id = parseInt(params.get('id'));
		this.objCustomers = new CustomersData();
	}

	ngOnInit() {
		this.route.params
		// (+) converts string 'id' to a number
		// .switchMap((params: Params) => this.CustomersService.getByID(+params['id']))
		.switchMap((params: Params) => this.CustomersService.getByID(params['id']))
		.subscribe((item: CustomersData) => this.objCustomers = item);
		this.getLookups();
	}

	updateCustomers() {
		this.CustomersService.updateCustomersData(this.objCustomers)
			.subscribe(record => this.router.navigate(['/Customers']),
				error =>  this.errorMessage = 'There was an error while updating record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Customers record updated successfully...', 'Edit Customers');
					console.log('Customers record updated successfully...'); 
				}
			);
	}
  
	deleteCustomers(id: string) {
		if (window.confirm('Are you sure you want to delete this Customers?') == true) 
		{
			this.CustomersService.deleteCustomers(this.objCustomers.CustomerID.toString())
			.subscribe(record => this.router.navigate(['/Customers']),
				error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error,
				() => { 
					this.toastr.success('Customers record deleted successfully...', 'Delete Customers');
					console.log('Customers record deleted successfully...'); 
				}
			);
		}
	}

	gotoCustomers() {
		let Id = this.objCustomers ? this.objCustomers.CustomerID : null;
		this.router.navigate(['/Customers']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Customers/CustomersEdit.component.ts